<template>
  <v-container>
    <material-card>
      <v-layout px-3 slot="header">
        <v-flex my-4 pl-4 title align-center justify-center>Uprawnienia {{ name }}</v-flex>

        <v-spacer />
      </v-layout>

      <v-layout text-xs-right>
        <v-flex>
          <check-permission permissions="PERMISSION_RELATION.ADD">
            <v-btn large color="error" @click="showAddModal">DODAJ UPRAWNIENIE</v-btn>
          </check-permission>
        </v-flex>
      </v-layout>

      <material-table
        entity-type="permission_relation"
        :actions="actions"
        :headers="headers"
        :items="list"
        @add="showAddModal"
        @delete="showDeleteDialog($event.permission.id)"
      />
    </material-card>

    <material-dialog
      title="Potwierdź usunięcie"
      text="Czy na pewno chcesz usunąć uprawnienie?"
      :show="!!idToDelete"
      :id="idToDelete"
      @close="hideDeleteDialog"
      @confirm="remove"
    />

    <modal :show="showModal" @save="add" @close="hideModal" />
  </v-container>
</template>

<script>
import { yesNo } from '@witkac/kartamiejska-shared';
import { mapState } from 'vuex';

import MaterialCard from '@/components/material/Card';
import MaterialDialog from '@/components/material/Dialog';
import MaterialTable from '@/components/material/Table';
import { listMixin } from '@/mixins/list';
import store from '@/store/store';
import { DELETE_ACTION } from '@/utils/actions';
import Modal from './add.modal';

// @vuese
// Uprawnienia roli
// @group Role
export default {
  mixins: [
    listMixin('roles/rolePermission', {
      listError: 'Nie udało się pobrać listy uprawnień.',
      added: 'Dodano uprawnienie.',
      addError: 'Nie udało się dodać uprawnienia.'
    })
  ],
  components: {
    MaterialCard,
    MaterialTable,
    MaterialDialog,
    Modal
  },
  methods: {
    // @vuese
    // Usuwa uprawnienie
    remove(id) {
      const data = { permissionId: id, roleId: this.roleId };
      store
        .dispatch(`roles/rolePermission/remove`, data)
        .then(() => this.notifySuccess('Usunięto uprawnienie.'))
        .catch(err => this.notifyError('Nie udało się usunąć uprawnienia.'));
    },
    // @vuese
    // Przeładowuje listę
    reloadList(route) {
      return this.$store
        .dispatch(`roles/rolePermission/list`, parseInt(route.params.id))
        .catch(err => this.notifyError(messages.listError));
    }
  },
  computed: {
    ...mapState({
      name: state => state.roles.data.name,
      roleId: state => state.roles.data.id,
      list: state => state.roles.rolePermission.list
    })
  },
  data() {
    return {
      headers: [
        { text: 'Nazwa', value: 'name', render: item => item.permission.name },
        { text: 'Dozwolone', value: 'allowed', render: item => yesNo(item.allowed) },
        { text: 'Dziedziczone', value: 'fromParent', render: item => yesNo(item.fromParent) }
      ],
      actions: [{ ...DELETE_ACTION, entityId: this.$route.params.id, check: item => !item.fromParent }]
    };
  }
};
</script>
